module.exports = __webpack_public_path__ + "img/send.13b4e56b.svg";